export const prospectIndustryOptions = [
    {
      "value": null,
      "label": "All Industries"
    },
    {
      "value": "Accommodation Services",
      "label": "Accommodation Services"
    },
    {
      "value": "Food and Beverage Services",
      "label": "Food and Beverage Services"
    },
    {
      "value": "Bars, Taverns, and Nightclubs",
      "label": "Bars, Taverns, and Nightclubs"
    },
    {
      "value": "Caterers",
      "label": "Caterers"
    },
    {
      "value": "Mobile Food Services",
      "label": "Mobile Food Services"
    },
    {
      "value": "Restaurants",
      "label": "Restaurants"
    },
    {
      "value": "Hospitality",
      "label": "Hospitality"
    },
    {
      "value": "Bed-and-Breakfasts, Hostels, Homestays",
      "label": "Bed-and-Breakfasts, Hostels, Homestays"
    },
    {
      "value": "Hotels and Motels",
      "label": "Hotels and Motels"
    },
    {
      "value": "Administrative and Support Services",
      "label": "Administrative and Support Services"
    },
    {
      "value": "Collection Agencies",
      "label": "Collection Agencies"
    },
    {
      "value": "Events Services",
      "label": "Events Services"
    },
    {
      "value": "Facilities Services",
      "label": "Facilities Services"
    },
    {
      "value": "Janitorial Services",
      "label": "Janitorial Services"
    },
    {
      "value": "Landscaping Services",
      "label": "Landscaping Services"
    },
    {
      "value": "Fundraising",
      "label": "Fundraising"
    },
    {
      "value": "Office Administration",
      "label": "Office Administration"
    },
    {
      "value": "Security and Investigations",
      "label": "Security and Investigations"
    },
    {
      "value": "Security Guards and Patrol Services",
      "label": "Security Guards and Patrol Services"
    },
    {
      "value": "Security Systems Services",
      "label": "Security Systems Services"
    },
    {
      "value": "Staffing and Recruiting",
      "label": "Staffing and Recruiting"
    },
    {
      "value": "Executive Search Services",
      "label": "Executive Search Services"
    },
    {
      "value": "Temporary Help Services",
      "label": "Temporary Help Services"
    },
    {
      "value": "Telephone Call Centers",
      "label": "Telephone Call Centers"
    },
    {
      "value": "Translation and Localization",
      "label": "Translation and Localization"
    },
    {
      "value": "Travel Arrangements",
      "label": "Travel Arrangements"
    },
    {
      "value": "Writing and Editing",
      "label": "Writing and Editing"
    },
    {
      "value": "Construction",
      "label": "Construction"
    },
    {
      "value": "Building Construction",
      "label": "Building Construction"
    },
    {
      "value": "Nonresidential Building Construction",
      "label": "Nonresidential Building Construction"
    },
    {
      "value": "Residential Building Construction",
      "label": "Residential Building Construction"
    },
    {
      "value": "Civil Engineering",
      "label": "Civil Engineering"
    },
    {
      "value": "Highway, Street, and Bridge Construction",
      "label": "Highway, Street, and Bridge Construction"
    },
    {
      "value": "Subdivision of Land",
      "label": "Subdivision of Land"
    },
    {
      "value": "Utility System Construction",
      "label": "Utility System Construction"
    },
    {
      "value": "Specialty Trade Contractors",
      "label": "Specialty Trade Contractors"
    },
    {
      "value": "Building Equipment Contractors",
      "label": "Building Equipment Contractors"
    },
    {
      "value": "Building Finishing Contractors",
      "label": "Building Finishing Contractors"
    },
    {
      "value": "Building Structure and Exterior Contractors",
      "label": "Building Structure and Exterior Contractors"
    },
    {
      "value": "Consumer Services",
      "label": "Consumer Services"
    },
    {
      "value": "Civic and Social Organizations",
      "label": "Civic and Social Organizations"
    },
    {
      "value": "Industry Associations",
      "label": "Industry Associations"
    },
    {
      "value": "Political Organizations",
      "label": "Political Organizations"
    },
    {
      "value": "Professional Organizations",
      "label": "Professional Organizations"
    },
    {
      "value": "Household Services",
      "label": "Household Services"
    },
    {
      "value": "Non-profit Organizations",
      "label": "Non-profit Organizations"
    },
    {
      "value": "Personal and Laundry Services",
      "label": "Personal and Laundry Services"
    },
    {
      "value": "Laundry and Drycleaning Services",
      "label": "Laundry and Drycleaning Services"
    },
    {
      "value": "Personal Care Services",
      "label": "Personal Care Services"
    },
    {
      "value": "Pet Services",
      "label": "Pet Services"
    },
    {
      "value": "Philanthropic Fundraising Services",
      "label": "Philanthropic Fundraising Services"
    },
    {
      "value": "Religious Institutions",
      "label": "Religious Institutions"
    },
    {
      "value": "Repair and Maintenance",
      "label": "Repair and Maintenance"
    },
    {
      "value": "Footwear and Leather Goods Repair",
      "label": "Footwear and Leather Goods Repair"
    },
    {
      "value": "Reupholstery and Furniture Repair",
      "label": "Reupholstery and Furniture Repair"
    },
    {
      "value": "Vehicle Repair and Maintenance",
      "label": "Vehicle Repair and Maintenance"
    },
    {
      "value": "Education",
      "label": "Education"
    },
    {
      "value": "E-Learning Providers",
      "label": "E-Learning Providers"
    },
    {
      "value": "Higher Education",
      "label": "Higher Education"
    },
    {
      "value": "Primary and Secondary Education",
      "label": "Primary and Secondary Education"
    },
    {
      "value": "Professional Training and Coaching",
      "label": "Professional Training and Coaching"
    },
    {
      "value": "Technical and Vocational Training",
      "label": "Technical and Vocational Training"
    },
    {
      "value": "Cosmetology and Barber Schools",
      "label": "Cosmetology and Barber Schools"
    },
    {
      "value": "Fine Arts Schools",
      "label": "Fine Arts Schools"
    },
    {
      "value": "Flight Training",
      "label": "Flight Training"
    },
    {
      "value": "Language Schools",
      "label": "Language Schools"
    },
    {
      "value": "Secretarial Schools",
      "label": "Secretarial Schools"
    },
    {
      "value": "Sports and Recreation Instruction",
      "label": "Sports and Recreation Instruction"
    },
    {
      "value": "Entertainment Providers",
      "label": "Entertainment Providers"
    },
    {
      "value": "Artists and Writers",
      "label": "Artists and Writers"
    },
    {
      "value": "Museums, Historical Sites, and Zoos",
      "label": "Museums, Historical Sites, and Zoos"
    },
    {
      "value": "Historical Sites",
      "label": "Historical Sites"
    },
    {
      "value": "Museums",
      "label": "Museums"
    },
    {
      "value": "Zoos and Botanical Gardens",
      "label": "Zoos and Botanical Gardens"
    },
    {
      "value": "Musicians",
      "label": "Musicians"
    },
    {
      "value": "Performing Arts and Spectator Sports",
      "label": "Performing Arts and Spectator Sports"
    },
    {
      "value": "Circuses and Magic Shows",
      "label": "Circuses and Magic Shows"
    },
    {
      "value": "Dance Companies",
      "label": "Dance Companies"
    },
    {
      "value": "Performing Arts",
      "label": "Performing Arts"
    },
    {
      "value": "Spectator Sports",
      "label": "Spectator Sports"
    },
    {
      "value": "Racetracks",
      "label": "Racetracks"
    },
    {
      "value": "Skiing Facilities",
      "label": "Skiing Facilities"
    },
    {
      "value": "Wellness and Fitness Services",
      "label": "Wellness and Fitness Services"
    },
    {
      "value": "Farming, Ranching, Forestry",
      "label": "Farming, Ranching, Forestry"
    },
    {
      "value": "Farming",
      "label": "Farming"
    },
    {
      "value": "Horticulture",
      "label": "Horticulture"
    },
    {
      "value": "Forestry and Logging",
      "label": "Forestry and Logging"
    },
    {
      "value": "Ranching and Fisheries",
      "label": "Ranching and Fisheries"
    },
    {
      "value": "Fisheries",
      "label": "Fisheries"
    },
    {
      "value": "Ranching",
      "label": "Ranching"
    },
    {
      "value": "Financial Services",
      "label": "Financial Services"
    },
    {
      "value": "Capital Markets",
      "label": "Capital Markets"
    },
    {
      "value": "Investment Advice",
      "label": "Investment Advice"
    },
    {
      "value": "Investment Banking",
      "label": "Investment Banking"
    },
    {
      "value": "Investment Management",
      "label": "Investment Management"
    },
    {
      "value": "Securities and Commodity Exchanges",
      "label": "Securities and Commodity Exchanges"
    },
    {
      "value": "Venture Capital and Private Equity Principals",
      "label": "Venture Capital and Private Equity Principals"
    },
    {
      "value": "Credit Intermediation",
      "label": "Credit Intermediation"
    },
    {
      "value": "Banking",
      "label": "Banking"
    },
    {
      "value": "International Trade and Development",
      "label": "International Trade and Development"
    },
    {
      "value": "Loan Brokers",
      "label": "Loan Brokers"
    },
    {
      "value": "Savings Institutions",
      "label": "Savings Institutions"
    },
    {
      "value": "Funds and Trusts",
      "label": "Funds and Trusts"
    },
    {
      "value": "Insurance and Employee Benefit Funds",
      "label": "Insurance and Employee Benefit Funds"
    },
    {
      "value": "Pension Funds",
      "label": "Pension Funds"
    },
    {
      "value": "Trusts and Estates",
      "label": "Trusts and Estates"
    },
    {
      "value": "Insurance",
      "label": "Insurance"
    },
    {
      "value": "Claims Adjusting, Actuarial Services",
      "label": "Claims Adjusting, Actuarial Services"
    },
    {
      "value": "Insurance Agencies and Brokerages",
      "label": "Insurance Agencies and Brokerages"
    },
    {
      "value": "Insurance Carriers",
      "label": "Insurance Carriers"
    },
    {
      "value": "Government Administration",
      "label": "Government Administration"
    },
    {
      "value": "Administration of Justice",
      "label": "Administration of Justice"
    },
    {
      "value": "Correctional Institutions",
      "label": "Correctional Institutions"
    },
    {
      "value": "Courts of Law",
      "label": "Courts of Law"
    },
    {
      "value": "Fire Protection",
      "label": "Fire Protection"
    },
    {
      "value": "Law Enforcement",
      "label": "Law Enforcement"
    },
    {
      "value": "Public Safety",
      "label": "Public Safety"
    },
    {
      "value": "Economic Programs",
      "label": "Economic Programs"
    },
    {
      "value": "Transportation Programs",
      "label": "Transportation Programs"
    },
    {
      "value": "Utilities Administration",
      "label": "Utilities Administration"
    },
    {
      "value": "Environmental Quality Programs",
      "label": "Environmental Quality Programs"
    },
    {
      "value": "Air, Water, and Waste Program Management",
      "label": "Air, Water, and Waste Program Management"
    },
    {
      "value": "Conservation Programs",
      "label": "Conservation Programs"
    },
    {
      "value": "Health and Human Services",
      "label": "Health and Human Services"
    },
    {
      "value": "Education Administration Programs",
      "label": "Education Administration Programs"
    },
    {
      "value": "Public Assistance Programs",
      "label": "Public Assistance Programs"
    },
    {
      "value": "Public Health",
      "label": "Public Health"
    },
    {
      "value": "Housing and Community Development",
      "label": "Housing and Community Development"
    },
    {
      "value": "Community Development and Urban Planning",
      "label": "Community Development and Urban Planning"
    },
    {
      "value": "Housing Programs",
      "label": "Housing Programs"
    },
    {
      "value": "Military and International Affairs",
      "label": "Military and International Affairs"
    },
    {
      "value": "Armed Forces",
      "label": "Armed Forces"
    },
    {
      "value": "International Affairs",
      "label": "International Affairs"
    },
    {
      "value": "Public Policy Offices",
      "label": "Public Policy Offices"
    },
    {
      "value": "Executive Offices",
      "label": "Executive Offices"
    },
    {
      "value": "Legislative Offices",
      "label": "Legislative Offices"
    },
    {
      "value": "Space Research and Technology",
      "label": "Space Research and Technology"
    },
    {
      "value": "Holding Companies",
      "label": "Holding Companies"
    },
    {
      "value": "Hospitals and Health Care",
      "label": "Hospitals and Health Care"
    },
    {
      "value": "Community Services",
      "label": "Community Services"
    },
    {
      "value": "Nursing Homes and Residential Care Facilities",
      "label": "Nursing Homes and Residential Care Facilities"
    },
    {
      "value": "Manufacturing",
      "label": "Manufacturing"
    },
    {
      "value": "Apparel Manufacturing",
      "label": "Apparel Manufacturing"
    },
    {
      "value": "Fashion Accessories Manufacturing",
      "label": "Fashion Accessories Manufacturing"
    },
    {
      "value": "Appliances, Electrical, and Electronics Manufacturing",
      "label": "Appliances, Electrical, and Electronics Manufacturing"
    },
    {
      "value": "Electric Lighting Equipment Manufacturing",
      "label": "Electric Lighting Equipment Manufacturing"
    },
    {
      "value": "Electrical Equipment Manufacturing",
      "label": "Electrical Equipment Manufacturing"
    },
    {
      "value": "Fuel Cell Manufacturing",
      "label": "Fuel Cell Manufacturing"
    },
    {
      "value": "Household Appliance Manufacturing",
      "label": "Household Appliance Manufacturing"
    },
    {
      "value": "Chemical Manufacturing",
      "label": "Chemical Manufacturing"
    },
    {
      "value": "Agricultural Chemical Manufacturing",
      "label": "Agricultural Chemical Manufacturing"
    },
    {
      "value": "Artificial Rubber and Synthetic Fiber Manufacturing",
      "label": "Artificial Rubber and Synthetic Fiber Manufacturing"
    },
    {
      "value": "Chemical Raw Materials Manufacturing",
      "label": "Chemical Raw Materials Manufacturing"
    },
    {
      "value": "Paint, Coating, and Adhesive Manufacturing",
      "label": "Paint, Coating, and Adhesive Manufacturing"
    },
    {
      "value": "Personal Care Product Manufacturing",
      "label": "Personal Care Product Manufacturing"
    },
    {
      "value": "Pharmaceutical Manufacturing",
      "label": "Pharmaceutical Manufacturing"
    },
    {
      "value": "Soap and Cleaning Product Manufacturing",
      "label": "Soap and Cleaning Product Manufacturing"
    },
    {
      "value": "Climate Technology Products Manufacturing",
      "label": "Climate Technology Products Manufacturing"
    },
    {
      "value": "Computers and Electronics Manufacturing",
      "label": "Computers and Electronics Manufacturing"
    },
    {
      "value": "Audio and Video Equipment Manufacturing",
      "label": "Audio and Video Equipment Manufacturing"
    },
    {
      "value": "Communications Equipment Manufacturing",
      "label": "Communications Equipment Manufacturing"
    },
    {
      "value": "Computer Hardware Manufacturing",
      "label": "Computer Hardware Manufacturing"
    },
    {
      "value": "Accessible Hardware Manufacturing",
      "label": "Accessible Hardware Manufacturing"
    },
    {
      "value": "Magnetic and Optical Media Manufacturing",
      "label": "Magnetic and Optical Media Manufacturing"
    },
    {
      "value": "Measuring and Control Instrument Manufacturing",
      "label": "Measuring and Control Instrument Manufacturing"
    },
    {
      "value": "Smart Meter Manufacturing",
      "label": "Smart Meter Manufacturing"
    },
    {
      "value": "Semiconductor Manufacturing",
      "label": "Semiconductor Manufacturing"
    },
    {
      "value": "Renewable Energy Semiconductor Manufacturing",
      "label": "Renewable Energy Semiconductor Manufacturing"
    },
    {
      "value": "Fabricated Metal Products Manufacturing",
      "label": "Fabricated Metal Products Manufacturing"
    },
    {
      "value": "Architectural and Structural Metal Manufacturing",
      "label": "Architectural and Structural Metal Manufacturing"
    },
    {
      "value": "Boilers, Tanks, and Shipping Container Manufacturing",
      "label": "Boilers, Tanks, and Shipping Container Manufacturing"
    },
    {
      "value": "Construction Hardware Manufacturing",
      "label": "Construction Hardware Manufacturing"
    },
    {
      "value": "Cutlery and Handtool Manufacturing",
      "label": "Cutlery and Handtool Manufacturing"
    },
    {
      "value": "Metal Treatments Manufacturing",
      "label": "Metal Treatments Manufacturing"
    },
    {
      "value": "Metal Valve, Ball, and Roller Manufacturing",
      "label": "Metal Valve, Ball, and Roller Manufacturing"
    },
    {
      "value": "Spring and Wire Product Manufacturing",
      "label": "Spring and Wire Product Manufacturing"
    },
    {
      "value": "Turned Products and Fastener Manufacturing",
      "label": "Turned Products and Fastener Manufacturing"
    },
    {
      "value": "Food and Beverage Manufacturing",
      "label": "Food and Beverage Manufacturing"
    },
    {
      "value": "Breweries",
      "label": "Breweries"
    },
    {
      "value": "Distilleries",
      "label": "Distilleries"
    },
    {
      "value": "Wineries",
      "label": "Wineries"
    },
    {
      "value": "Animal Feed Manufacturing",
      "label": "Animal Feed Manufacturing"
    },
    {
      "value": "Baked Goods Manufacturing",
      "label": "Baked Goods Manufacturing"
    },
    {
      "value": "Beverage Manufacturing",
      "label": "Beverage Manufacturing"
    },
    {
      "value": "Dairy Product Manufacturing",
      "label": "Dairy Product Manufacturing"
    },
    {
      "value": "Fruit and Vegetable Preserves Manufacturing",
      "label": "Fruit and Vegetable Preserves Manufacturing"
    },
    {
      "value": "Meat Products Manufacturing",
      "label": "Meat Products Manufacturing"
    },
    {
      "value": "Seafood Product Manufacturing",
      "label": "Seafood Product Manufacturing"
    },
    {
      "value": "Sugar and Confectionery Product Manufacturing",
      "label": "Sugar and Confectionery Product Manufacturing"
    },
    {
      "value": "Furniture and Home Furnishings Manufacturing",
      "label": "Furniture and Home Furnishings Manufacturing"
    },
    {
      "value": "Household and Institutional Furniture Manufacturing",
      "label": "Household and Institutional Furniture Manufacturing"
    },
    {
      "value": "Mattress and Blinds Manufacturing",
      "label": "Mattress and Blinds Manufacturing"
    },
    {
      "value": "Office Furniture and Fixtures Manufacturing",
      "label": "Office Furniture and Fixtures Manufacturing"
    },
    {
      "value": "Glass, Ceramics and Concrete Manufacturing",
      "label": "Glass, Ceramics and Concrete Manufacturing"
    },
    {
      "value": "Abrasives and Nonmetallic Minerals Manufacturing",
      "label": "Abrasives and Nonmetallic Minerals Manufacturing"
    },
    {
      "value": "Clay and Refractory Products Manufacturing",
      "label": "Clay and Refractory Products Manufacturing"
    },
    {
      "value": "Glass Product Manufacturing",
      "label": "Glass Product Manufacturing"
    },
    {
      "value": "Lime and Gypsum Products Manufacturing",
      "label": "Lime and Gypsum Products Manufacturing"
    },
    {
      "value": "Leather Product Manufacturing",
      "label": "Leather Product Manufacturing"
    },
    {
      "value": "Footwear Manufacturing",
      "label": "Footwear Manufacturing"
    },
    {
      "value": "Women's Handbag Manufacturing",
      "label": "Women's Handbag Manufacturing"
    },
    {
      "value": "Machinery Manufacturing",
      "label": "Machinery Manufacturing"
    },
    {
      "value": "Agriculture, Construction, Mining Machinery Manufacturing",
      "label": "Agriculture, Construction, Mining Machinery Manufacturing"
    },
    {
      "value": "Automation Machinery Manufacturing",
      "label": "Automation Machinery Manufacturing"
    },
    {
      "value": "Robot Manufacturing",
      "label": "Robot Manufacturing"
    },
    {
      "value": "Commercial and Service Industry Machinery Manufacturing",
      "label": "Commercial and Service Industry Machinery Manufacturing"
    },
    {
      "value": "Engines and Power Transmission Equipment Manufacturing",
      "label": "Engines and Power Transmission Equipment Manufacturing"
    },
    {
      "value": "Renewable Energy Equipment Manufacturing",
      "label": "Renewable Energy Equipment Manufacturing"
    },
    {
      "value": "HVAC and Refrigeration Equipment Manufacturing",
      "label": "HVAC and Refrigeration Equipment Manufacturing"
    },
    {
      "value": "Industrial Machinery Manufacturing",
      "label": "Industrial Machinery Manufacturing"
    },
    {
      "value": "Metalworking Machinery Manufacturing",
      "label": "Metalworking Machinery Manufacturing"
    },
    {
      "value": "Medical Equipment Manufacturing",
      "label": "Medical Equipment Manufacturing"
    },
    {
      "value": "Oil and Coal Product Manufacturing",
      "label": "Oil and Coal Product Manufacturing"
    },
    {
      "value": "Paper and Forest Product Manufacturing",
      "label": "Paper and Forest Product Manufacturing"
    },
    {
      "value": "Plastics and Rubber Product Manufacturing",
      "label": "Plastics and Rubber Product Manufacturing"
    },
    {
      "value": "Packaging and Containers Manufacturing",
      "label": "Packaging and Containers Manufacturing"
    },
    {
      "value": "Plastics Manufacturing",
      "label": "Plastics Manufacturing"
    },
    {
      "value": "Rubber Products Manufacturing",
      "label": "Rubber Products Manufacturing"
    },
    {
      "value": "Primary Metal Manufacturing",
      "label": "Primary Metal Manufacturing"
    },
    {
      "value": "Printing Services",
      "label": "Printing Services"
    },
    {
      "value": "Sporting Goods Manufacturing",
      "label": "Sporting Goods Manufacturing"
    },
    {
      "value": "Textile Manufacturing",
      "label": "Textile Manufacturing"
    },
    {
      "value": "Tobacco Manufacturing",
      "label": "Tobacco Manufacturing"
    },
    {
      "value": "Transportation Equipment Manufacturing",
      "label": "Transportation Equipment Manufacturing"
    },
    {
      "value": "Aviation and Aerospace Component Manufacturing",
      "label": "Aviation and Aerospace Component Manufacturing"
    },
    {
      "value": "Defense and Space Manufacturing",
      "label": "Defense and Space Manufacturing"
    },
    {
      "value": "Motor Vehicle Manufacturing",
      "label": "Motor Vehicle Manufacturing"
    },
    {
      "value": "Alternative Fuel Vehicle Manufacturing",
      "label": "Alternative Fuel Vehicle Manufacturing"
    },
    {
      "value": "Motor Vehicle Parts Manufacturing",
      "label": "Motor Vehicle Parts Manufacturing"
    },
    {
      "value": "Railroad Equipment Manufacturing",
      "label": "Railroad Equipment Manufacturing"
    },
    {
      "value": "Shipbuilding",
      "label": "Shipbuilding"
    },
    {
      "value": "Wood Product Manufacturing",
      "label": "Wood Product Manufacturing"
    },
    {
      "value": "Oil, Gas, and Mining",
      "label": "Oil, Gas, and Mining"
    },
    {
      "value": "Mining",
      "label": "Mining"
    },
    {
      "value": "Coal Mining",
      "label": "Coal Mining"
    },
    {
      "value": "Metal Ore Mining",
      "label": "Metal Ore Mining"
    },
    {
      "value": "Nonmetallic Mineral Mining",
      "label": "Nonmetallic Mineral Mining"
    },
    {
      "value": "Oil and Gas",
      "label": "Oil and Gas"
    },
    {
      "value": "Natural Gas Extraction",
      "label": "Natural Gas Extraction"
    },
    {
      "value": "Oil Extraction",
      "label": "Oil Extraction"
    },
    {
      "value": "Professional Services",
      "label": "Professional Services"
    },
    {
      "value": "Advertising Services",
      "label": "Advertising Services"
    },
    {
      "value": "Government Relations Services",
      "label": "Government Relations Services"
    },
    {
      "value": "Public Relations and Communications Services",
      "label": "Public Relations and Communications Services"
    },
    {
      "value": "Market Research",
      "label": "Market Research"
    },
    {
      "value": "Architecture and Planning",
      "label": "Architecture and Planning"
    },
    {
      "value": "Accessible Architecture and Design",
      "label": "Accessible Architecture and Design"
    },
    {
      "value": "Business Consulting and Services",
      "label": "Business Consulting and Services"
    },
    {
      "value": "Environmental Services",
      "label": "Environmental Services"
    },
    {
      "value": "Human Resources Services",
      "label": "Human Resources Services"
    },
    {
      "value": "Marketing Services",
      "label": "Marketing Services"
    },
    {
      "value": "Operations Consulting",
      "label": "Operations Consulting"
    },
    {
      "value": "Outsourcing and Offshoring Consulting",
      "label": "Outsourcing and Offshoring Consulting"
    },
    {
      "value": "Strategic Management Services",
      "label": "Strategic Management Services"
    },
    {
      "value": "Design Services",
      "label": "Design Services"
    },
    {
      "value": "Graphic Design",
      "label": "Graphic Design"
    },
    {
      "value": "Regenerative Design",
      "label": "Regenerative Design"
    },
    {
      "value": "Interior Design",
      "label": "Interior Design"
    },
    {
      "value": "Engineering Services",
      "label": "Engineering Services"
    },
    {
      "value": "Robotics Engineering",
      "label": "Robotics Engineering"
    },
    {
      "value": "Surveying and Mapping Services",
      "label": "Surveying and Mapping Services"
    },
    {
      "value": "IT Services and IT Consulting",
      "label": "IT Services and IT Consulting"
    },
    {
      "value": "Computer and Network Security",
      "label": "Computer and Network Security"
    },
    {
      "value": "Digital Accessibility Services",
      "label": "Digital Accessibility Services"
    },
    {
      "value": "IT System Custom Software Development",
      "label": "IT System Custom Software Development"
    },
    {
      "value": "IT System Data Services",
      "label": "IT System Data Services"
    },
    {
      "value": "IT System Design Services",
      "label": "IT System Design Services"
    },
    {
      "value": "IT System Installation and Disposal",
      "label": "IT System Installation and Disposal"
    },
    {
      "value": "IT System Operations and Maintenance",
      "label": "IT System Operations and Maintenance"
    },
    {
      "value": "IT System Testing and Evaluation",
      "label": "IT System Testing and Evaluation"
    },
    {
      "value": "IT System Training and Support",
      "label": "IT System Training and Support"
    },
    {
      "value": "Legal Services",
      "label": "Legal Services"
    },
    {
      "value": "Alternative Dispute Resolution",
      "label": "Alternative Dispute Resolution"
    },
    {
      "value": "Law Practice",
      "label": "Law Practice"
    },
    {
      "value": "Photography",
      "label": "Photography"
    },
    {
      "value": "Research Services",
      "label": "Research Services"
    },
    {
      "value": "Biotechnology Research",
      "label": "Biotechnology Research"
    },
    {
      "value": "Nanotechnology Research",
      "label": "Nanotechnology Research"
    },
    {
      "value": "Think Tanks",
      "label": "Think Tanks"
    },
    {
      "value": "Services for Renewable Energy",
      "label": "Services for Renewable Energy"
    },
    {
      "value": "Veterinary Services",
      "label": "Veterinary Services"
    },
    {
      "value": "Real Estate and Equipment Rental Services",
      "label": "Real Estate and Equipment Rental Services"
    },
    {
      "value": "Equipment Rental Services",
      "label": "Equipment Rental Services"
    },
    {
      "value": "Commercial and Industrial Equipment Rental",
      "label": "Commercial and Industrial Equipment Rental"
    },
    {
      "value": "Consumer Goods Rental",
      "label": "Consumer Goods Rental"
    },
    {
      "value": "Real Estate",
      "label": "Real Estate"
    },
    {
      "value": "Leasing Non-residential Real Estate",
      "label": "Leasing Non-residential Real Estate"
    },
    {
      "value": "Leasing Residential Real Estate",
      "label": "Leasing Residential Real Estate"
    },
    {
      "value": "Real Estate Agents and Brokers",
      "label": "Real Estate Agents and Brokers"
    },
    {
      "value": "Retail",
      "label": "Retail"
    },
    {
      "value": "Food and Beverage Retail",
      "label": "Food and Beverage Retail"
    },
    {
      "value": "Retail Groceries",
      "label": "Retail Groceries"
    },
    {
      "value": "Online and Mail Order Retail",
      "label": "Online and Mail Order Retail"
    },
    {
      "value": "Retail Apparel and Fashion",
      "label": "Retail Apparel and Fashion"
    },
    {
      "value": "Retail Appliances, Electrical, and Electronic Equipment",
      "label": "Retail Appliances, Electrical, and Electronic Equipment"
    },
    {
      "value": "Retail Art Dealers",
      "label": "Retail Art Dealers"
    },
    {
      "value": "Retail Art Supplies",
      "label": "Retail Art Supplies"
    },
    {
      "value": "Retail Books and Printed News",
      "label": "Retail Books and Printed News"
    },
    {
      "value": "Retail Building Materials and Garden Equipment",
      "label": "Retail Building Materials and Garden Equipment"
    },
    {
      "value": "Retail Florists",
      "label": "Retail Florists"
    },
    {
      "value": "Retail Furniture and Home Furnishings",
      "label": "Retail Furniture and Home Furnishings"
    },
    {
      "value": "Retail Gasoline",
      "label": "Retail Gasoline"
    },
    {
      "value": "Retail Health and Personal Care Products",
      "label": "Retail Health and Personal Care Products"
    },
    {
      "value": "Retail Pharmacies",
      "label": "Retail Pharmacies"
    },
    {
      "value": "Retail Luxury Goods and Jewelry",
      "label": "Retail Luxury Goods and Jewelry"
    },
    {
      "value": "Retail Motor Vehicles",
      "label": "Retail Motor Vehicles"
    },
    {
      "value": "Retail Musical Instruments",
      "label": "Retail Musical Instruments"
    },
    {
      "value": "Retail Office Equipment",
      "label": "Retail Office Equipment"
    },
    {
      "value": "Retail Office Supplies and Gifts",
      "label": "Retail Office Supplies and Gifts"
    },
    {
      "value": "Retail Recyclable Materials & Used Merchandise",
      "label": "Retail Recyclable Materials & Used Merchandise"
    },
    {
      "value": "Technology, Information and Media",
      "label": "Technology, Information and Media"
    },
    {
      "value": "Media & Telecommunications",
      "label": "Media & Telecommunications"
    },
    {
      "value": "Book and Periodical Publishing",
      "label": "Book and Periodical Publishing"
    },
    {
      "value": "Book Publishing",
      "label": "Book Publishing"
    },
    {
      "value": "Newspaper Publishing",
      "label": "Newspaper Publishing"
    },
    {
      "value": "Periodical Publishing",
      "label": "Periodical Publishing"
    },
    {
      "value": "Broadcast Media Production and Distribution",
      "label": "Broadcast Media Production and Distribution"
    },
    {
      "value": "Cable and Satellite Programming",
      "label": "Cable and Satellite Programming"
    },
    {
      "value": "Radio and Television Broadcasting",
      "label": "Radio and Television Broadcasting"
    },
    {
      "value": "Movies, Videos and Sound",
      "label": "Movies, Videos and Sound"
    },
    {
      "value": "Animation and Post-production",
      "label": "Animation and Post-production"
    },
    {
      "value": "Media Production",
      "label": "Media Production"
    },
    {
      "value": "Movies and Sound Recording",
      "label": "Movies and Sound Recording"
    },
    {
      "value": "Sound Recording",
      "label": "Sound Recording"
    },
    {
      "value": "Sheet Music Publishing",
      "label": "Sheet Music Publishing"
    },
    {
      "value": "Telecommunications",
      "label": "Telecommunications"
    },
    {
      "value": "Satellite Telecommunications",
      "label": "Satellite Telecommunications"
    },
    {
      "value": "Telecommunications Carriers",
      "label": "Telecommunications Carriers"
    },
    {
      "value": "Wireless Services",
      "label": "Wireless Services"
    },
    {
      "value": "Technology, Information and Internet",
      "label": "Technology, Information and Internet"
    },
    {
      "value": "Data Infrastructure and Analytics",
      "label": "Data Infrastructure and Analytics"
    },
    {
      "value": "Blockchain Services",
      "label": "Blockchain Services"
    },
    {
      "value": "Business Intelligence Platforms",
      "label": "Business Intelligence Platforms"
    },
    {
      "value": "Climate Data and Analytics",
      "label": "Climate Data and Analytics"
    },
    {
      "value": "Information Services",
      "label": "Information Services"
    },
    {
      "value": "Internet Publishing",
      "label": "Internet Publishing"
    },
    {
      "value": "Business Content",
      "label": "Business Content"
    },
    {
      "value": "Online Audio and Video Media",
      "label": "Online Audio and Video Media"
    },
    {
      "value": "Internet News",
      "label": "Internet News"
    },
    {
      "value": "Libraries",
      "label": "Libraries"
    },
    {
      "value": "Blogs",
      "label": "Blogs"
    },
    {
      "value": "Internet Marketplace Platforms",
      "label": "Internet Marketplace Platforms"
    },
    {
      "value": "Social Networking Platforms",
      "label": "Social Networking Platforms"
    },
    {
      "value": "Software Development",
      "label": "Software Development"
    },
    {
      "value": "Computer Games",
      "label": "Computer Games"
    },
    {
      "value": "Mobile Gaming Apps",
      "label": "Mobile Gaming Apps"
    },
    {
      "value": "Computer Networking Products",
      "label": "Computer Networking Products"
    },
    {
      "value": "Data Security Software Products",
      "label": "Data Security Software Products"
    },
    {
      "value": "Desktop Computing Software Products",
      "label": "Desktop Computing Software Products"
    },
    {
      "value": "Embedded Software Products",
      "label": "Embedded Software Products"
    },
    {
      "value": "Mobile Computing Software Products",
      "label": "Mobile Computing Software Products"
    },
    {
      "value": "Transportation, Logistics, Supply Chain and Storage",
      "label": "Transportation, Logistics, Supply Chain and Storage"
    },
    {
      "value": "Airlines and Aviation",
      "label": "Airlines and Aviation"
    },
    {
      "value": "Freight and Package Transportation",
      "label": "Freight and Package Transportation"
    },
    {
      "value": "Ground Passenger Transportation",
      "label": "Ground Passenger Transportation"
    },
    {
      "value": "Interurban and Rural Bus Services",
      "label": "Interurban and Rural Bus Services"
    },
    {
      "value": "School and Employee Bus Services",
      "label": "School and Employee Bus Services"
    },
    {
      "value": "Shuttles and Special Needs Transportation Services",
      "label": "Shuttles and Special Needs Transportation Services"
    },
    {
      "value": "Sightseeing Transportation",
      "label": "Sightseeing Transportation"
    },
    {
      "value": "Taxi and Limousine Services",
      "label": "Taxi and Limousine Services"
    },
    {
      "value": "Urban Transit Services",
      "label": "Urban Transit Services"
    },
    {
      "value": "Maritime Transportation",
      "label": "Maritime Transportation"
    },
    {
      "value": "Pipeline Transportation",
      "label": "Pipeline Transportation"
    },
    {
      "value": "Postal Services",
      "label": "Postal Services"
    },
    {
      "value": "Rail Transportation",
      "label": "Rail Transportation"
    },
    {
      "value": "Truck Transportation",
      "label": "Truck Transportation"
    },
    {
      "value": "Warehousing and Storage",
      "label": "Warehousing and Storage"
    },
    {
      "value": "Utilities",
      "label": "Utilities"
    },
    {
      "value": "Electric Power Generation",
      "label": "Electric Power Generation"
    },
    {
      "value": "Fossil Fuel Electric Power Generation",
      "label": "Fossil Fuel Electric Power Generation"
    },
    {
      "value": "Nuclear Electric Power Generation",
      "label": "Nuclear Electric Power Generation"
    },
    {
      "value": "Renewable Energy Power Generation",
      "label": "Renewable Energy Power Generation"
    },
    {
      "value": "Biomass Electric Power Generation",
      "label": "Biomass Electric Power Generation"
    },
    {
      "value": "Geothermal Electric Power Generation",
      "label": "Geothermal Electric Power Generation"
    },
    {
      "value": "Hydroelectric Power Generation",
      "label": "Hydroelectric Power Generation"
    },
    {
      "value": "Solar Electric Power Generation",
      "label": "Solar Electric Power Generation"
    },
    {
      "value": "Wind Electric Power Generation",
      "label": "Wind Electric Power Generation"
    },
    {
      "value": "Electric Power Transmission, Control, and Distribution",
      "label": "Electric Power Transmission, Control, and Distribution"
    },
    {
      "value": "Natural Gas Distribution",
      "label": "Natural Gas Distribution"
    },
    {
      "value": "Water, Waste, Steam, and Air Conditioning Services",
      "label": "Water, Waste, Steam, and Air Conditioning Services"
    },
    {
      "value": "Steam and Air-Conditioning Supply",
      "label": "Steam and Air-Conditioning Supply"
    },
    {
      "value": "Waste Collection",
      "label": "Waste Collection"
    },
    {
      "value": "Waste Treatment and Disposal",
      "label": "Waste Treatment and Disposal"
    },
    {
      "value": "Water Supply and Irrigation Systems",
      "label": "Water Supply and Irrigation Systems"
    },
    {
      "value": "Wholesale",
      "label": "Wholesale"
    },
    {
      "value": "Wholesale Alcoholic Beverages",
      "label": "Wholesale Alcoholic Beverages"
    },
    {
      "value": "Wholesale Apparel and Sewing Supplies",
      "label": "Wholesale Apparel and Sewing Supplies"
    },
    {
      "value": "Wholesale Appliances, Electrical, and Electronics",
      "label": "Wholesale Appliances, Electrical, and Electronics"
    },
    {
      "value": "Wholesale Building Materials",
      "label": "Wholesale Building Materials"
    },
    {
      "value": "Wholesale Chemical and Allied Products",
      "label": "Wholesale Chemical and Allied Products"
    },
    {
      "value": "Wholesale Computer Equipment",
      "label": "Wholesale Computer Equipment"
    },
    {
      "value": "Wholesale Drugs and Sundries",
      "label": "Wholesale Drugs and Sundries"
    },
    {
      "value": "Wholesale Food and Beverage",
      "label": "Wholesale Food and Beverage"
    },
    {
      "value": "Wholesale Footwear",
      "label": "Wholesale Footwear"
    },
    {
      "value": "Wholesale Furniture and Home Furnishings",
      "label": "Wholesale Furniture and Home Furnishings"
    },
    {
      "value": "Wholesale Hardware, Plumbing, Heating Equipment",
      "label": "Wholesale Hardware, Plumbing, Heating Equipment"
    },
    {
      "value": "Wholesale Import and Export",
      "label": "Wholesale Import and Export"
    },
    {
      "value": "Wholesale Luxury Goods and Jewelry",
      "label": "Wholesale Luxury Goods and Jewelry"
    },
    {
      "value": "Wholesale Machinery",
      "label": "Wholesale Machinery"
    },
    {
      "value": "Wholesale Metals and Minerals",
      "label": "Wholesale Metals and Minerals"
    },
    {
      "value": "Wholesale Motor Vehicles and Parts",
      "label": "Wholesale Motor Vehicles and Parts"
    },
    {
      "value": "Wholesale Paper Products",
      "label": "Wholesale Paper Products"
    },
    {
      "value": "Wholesale Petroleum and Petroleum Products",
      "label": "Wholesale Petroleum and Petroleum Products"
    },
    {
      "value": "Wholesale Photography Equipment and Supplies",
      "label": "Wholesale Photography Equipment and Supplies"
    },
    {
      "value": "Wholesale Raw Farm Products",
      "label": "Wholesale Raw Farm Products"
    },
    {
      "value": "Wholesale Recyclable Materials",
      "label": "Wholesale Recyclable Materials"
    }
  ]